/**
 * Constantes dos limites definidos no backend para o endpoint ncmDetalhesDrillDown
 * Baseado no arquivo: elevate_api/app/Http/Controllers/SpedFiscalResumoController.php
 * 
 * Estes valores devem corresponder exatamente aos limits() definidos nas queries do backend
 */

export const NCM_DRILL_DOWN_LIMITS = {
  /**
   * Limite para top CFOPs por valor de ICMS
   * Backend: linha 1247 ->limit(5)
   */
  TOP_CFOPS: 5,

  /**
   * Limite para principais produtos do NCM
   * Backend: linha 1268 ->limit(10) 
   */
  PRINCIPAIS_PRODUTOS: 10,

  /**
   * Limite para principais parceiros comerciais (fornecedores e clientes)
   * Backend: linha 1324 ->limit(10)
   */
  PARCEIROS_COMERCIAIS: 10,

  /**
   * Limite para transações detalhadas recentes
   * Backend: linha 1369 ->limit(20)
   */
  TRANSACOES_DETALHADAS: 20
} as const;

/**
 * Função helper para gerar títulos com limites dinâmicos
 */
export const generateTitleWithLimit = (baseTitle: string, limit: number): string => {
  return `${baseTitle} (até ${limit} registros)`;
};

/**
 * Títulos pré-formatados para componentes do NCM DrillDown
 */
export const NCM_DRILL_DOWN_TITLES = {
  PRINCIPAIS_PRODUTOS: generateTitleWithLimit('Principais Produtos do NCM', NCM_DRILL_DOWN_LIMITS.PRINCIPAIS_PRODUTOS),
  ANALISE_CFOP: generateTitleWithLimit('Análise por CFOP - NCM', NCM_DRILL_DOWN_LIMITS.TOP_CFOPS),
  TRANSACOES_DETALHADAS: generateTitleWithLimit('Principais Transações Detalhadas - NCM', NCM_DRILL_DOWN_LIMITS.TRANSACOES_DETALHADAS),
  PARCEIROS_COMERCIAIS: 'Parceiros Comerciais - NCM' // Este mantém subtítulos internos com limites
} as const; 